import React, { useEffect } from "react";
import Auth from "./Auth";
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';

const ProtectedRoutes = ({ component: Component, ...rest }) => {


  const navigate = useNavigate();
  const curr_location = useLocation()
  useEffect(() => {
    const tokeninfo1 = localStorage.getItem("tokeninfo");
    const tokeninfo = tokeninfo1 ? JSON.parse(tokeninfo1) : null;
    if (tokeninfo) {
      Auth.signin(() => {
        navigate(`${curr_location.pathname}`)
      })
    } else {
      Auth.signout(() => {
        navigate('/login')
      })
    }

  }, [])


  return (
    Auth.getAuth() ? (
      <Outlet />
    ) : (
      <Navigate to="/login" />
    )
  );
};

export default ProtectedRoutes;
